module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.site) ? _c('div', {
    staticClass: "padded"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.rowData.siteName))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.rowData.siteId))]), _vm._v(" "), (!_vm.site.address) ? _c('span', [_vm._v("Council "), _c('strong', [_vm._v(_vm._s(_vm.site.zone))])]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.site.subdistrict))]), _vm._v(" "), (_vm.site.district) ? _c('i', [(_vm.site.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.district))]) : _vm._e(), _vm._v(" "), (_vm.site.region) ? _c('i', [(_vm.site.district || _vm.site.subdistrict) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.region))]) : _vm._e(), _vm._v(" "), (_vm.site.state) ? _c('i', [(_vm.site.district || _vm.site.subdistrict || _vm.site.region) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.state))]) : _vm._e(), _vm._v(" "), (_vm.site.country) ? _c('i', [(_vm.site.district || _vm.site.subdistrict || _vm.site.region || _vm.site.state) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(_vm._s(_vm.site.country))]) : _vm._e()])], 1), _vm._v(" "), (_vm.site.address) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.address))]), _vm._v("  \n        Local Council "), _c('strong', [_vm._v(_vm._s(_vm.site.zone))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('small', [_vm._v("lat:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.site.latitude))]), _vm._v(" / "), _c('small', [_vm._v("lng:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.site.longitude))])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isEmptyObject(_vm.action)) ? _c('el-tabs', {
    attrs: {
      "type": "card",
      "stretch": ""
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" " + _vm._s(_vm.action.steps[0].stepName))]), _vm._v(" "), _c('progress-step1', {
    attrs: {
      "site-id": _vm.rowData.site_id,
      "row-data": _vm.action,
      "step-data": _vm.action.steps[0],
      "read-only": true
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" " + _vm._s(_vm.action.steps[1].stepName))]), _vm._v(" "), _c('Progress-step2', {
    attrs: {
      "site-id": _vm.rowData.site_id,
      "row-data": _vm.action,
      "step-data": _vm.action.steps[1],
      "read-only": true
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" " + _vm._s(_vm.action.steps[2].stepName))]), _vm._v(" "), _c('progress-step3', {
    attrs: {
      "site-id": _vm.rowData.site_id,
      "row-data": _vm.action,
      "step-data": _vm.action.steps[2],
      "read-only": true
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-recycle"
  }), _vm._v(" " + _vm._s(_vm.action.steps[3].stepName))]), _vm._v(" "), _c('progress-step4', {
    attrs: {
      "site-id": _vm.rowData.site_id,
      "row-data": _vm.action,
      "step-data": _vm.action.steps[3],
      "read-only": true
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" Land Owner")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h2', [_vm._v("Land Owner")]), _vm._v(" "), (!_vm.hasLandowner(_vm.site)) ? _c('div', [_c('center', [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("No landowner information found")])])], 1) : _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                  Owner\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.name))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                  Address\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.address))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                  Post Code\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.postCode))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                  Phone\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.phone))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                  e-Mail\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.site.tenancy.owner.email))])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.site.landStarted) ? _c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])]), _vm._v(" "), _c('tfoot'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.site.landType) + " Agreement")]), _vm._v(" "), _c('td', [_c('strong', {
    class: _vm.isOverdue(_vm.site.landExpiry) ? 'text-primary' : 'text-success'
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.site.landStarted)))])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Deposit Paid")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(_vm.site.landDeposit)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.site.frequency) + " Rental")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatNumber(_vm.site.landPayment)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Agreement Expiry")]), _vm._v(" "), _c('td', [_c('strong', {
    class: _vm.isOverdue(_vm.site.landExpiry) ? 'text-warning' : 'text-primary'
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.site.landExpiry)))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(_vm.formatFriendlyDate(_vm.site.landExpiry)) + ")")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Renewal Increment")]), _vm._v(" "), _c('td', [(_vm.site.term) ? _c('span', [_c('strong', [_vm._v(_vm._s(_vm.site.term))]), _vm._v("\n                      " + _vm._s(_vm.site.term > 1 ? 'times' : 'time') + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatNumber(_vm.site.renewalIncrement)))]), _vm._v(" %")])])])]) : _vm._e()])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.site.handover) ? _c('small', [_vm._v("Handover ")]) : _vm._e(), _vm._v(" \n    "), (_vm.site.handover) ? _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.site.handover)))]) : _vm._e()]), _vm._v(" "), (_vm.site.landExpiry) ? _c('small', [_vm._v("Land Expiry ")]) : _vm._e(), _vm._v(" \n      "), (_vm.site.landExpiry) ? _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.site.landExpiry)))]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7,
      "offset": 1
    }
  }, [_vm._v("\n       "), (_vm.site.billing) ? _c('small', [_vm._v("Commencement")]) : _vm._e(), _vm._v(" "), (_vm.site.billing) ? _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.site.billing)))]) : _vm._e()])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ccb9b5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressDetail.vue
// module id = 1471
// module chunks = 0